module.exports = __webpack_public_path__ + "static/media/grusha.d20bfef1.jpg";